'use strict';

/**
 * Slick carousel initializer.
 *
 * Finds every .amp-slick-carousel element, reads its JSON config from the
 * matching application/json script tag (linked via data-config-for), and
 * calls jQuery .slick() with those options. Supports multiple carousels
 * on the same page.
 */

/**
 * Initializes a single Slick carousel element when config is available.
 * @param {HTMLElement} carouselEl - Carousel root element.
 * @returns {void}
 * @private
 */
function _initSlickCarouselElement(carouselEl) {
    let id = carouselEl.id;

    if (!id) return;
    if (carouselEl.classList.contains('slick-initialized')) return;

    let configEl = document.querySelector(`[data-config-for="${id}"]`);
    if (!configEl) return;

    let opts;
    try {
        opts = JSON.parse(configEl.textContent);
    } catch (e) {
        return;
    }

    let $carousel = jQuery(`#${id}`);

    if (!$carousel.length) return;

    try {
        $carousel.slick(opts);
    } catch (e) {
        return;
    }
}

/**
 * Initializes all Amplience Slick carousels on the page.
 */
export function initSlickCarousels() {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    let carousels = document.querySelectorAll('.amp-slick-carousel');

    for (let i = 0; i < carousels.length; i++) {
        _initSlickCarouselElement(carousels[i]);
    }
}
